function LoadingRoute() {
  return <div className="text-center mt-40">Loading ...</div>;
}

export default LoadingRoute;
